module.exports = __webpack_public_path__ + "img/champion-show-title.9f36ea00.png";